import { WasteStreamAgreement } from './types'

export const ORDER_TYPE_LABELS = {
  AFTRANSPORT: 'Aftransport',
  SKIP_COLLECTION: 'Skip Collection',
  COMMERCIAL_COLLECTION: 'Commercial Collection',
}

// Dummy Internal Collector ID/Name
export const INTERNAL_COLLECTOR_NAME = 'Regio Gooi en Vechtstreek (GAD)'

export const DISPOSERS_WITH_SERVICE_POINTS: Record<string, string[]> = {
  'Regio Gooi en Vechtstreek (GAD)': [],
  'BAM Bouw en Techniek': [],
  'Heijmans Woningbouw': [],
  'Erasmus MC (Rotterdam)': [],
  'Tergooi MC': [],
  'Maasstad Ziekenhuis (Rotterdam)': [],
  'Port of Rotterdam Authority': [],
  'Tata Steel IJmuiden': [],
  'Municipality of Rotterdam': [],
  'Gemeente Amsterdam': [],
  'Reinis N.V.': [],
}

export const WASTE_TYPES = [
  'Infectious Medical Waste - 18 01 03*',
  'Pharmaceutical Waste - 18 01 09',
  'Mixed Municipal Waste - 20 03 01',
  'Biodegradable Kitchen/Garden Waste - 20 01 08',
  'Plastic Packaging - 15 01 02',
  'Paper and Cardboard - 20 01 01',
  'Bulky Waste - 20 03 07',
  'Construction & Demolition Waste - 17 09 04',
  'Contaminated Soil - 17 05 03*',
  'Laboratory Chemicals - 16 05 06*',
  'Discarded Electronic Equipment - 16 02 14',
  'Construction Materials Containing Asbestos - 17 06 05*',
  'Mineral-Based Engine Oils - 13 02 05*',
  'Packaging Containing Hazardous Residues - 15 01 10*',
]

export const RECEIVERS = [
  'AEB Amsterdam',
  'AVR Afvalverwerking',
  'Attero',
  'Indaver NL',
  'Renewi',
  'SUEZ / PreZero',
  'ZAVIN',
  'HVC',
  'Orgaworld',
]

export const PROCESSING_METHODS = [
  'R1: Main use as fuel or other energy generation',
  'R2: Recovery of solvents',
  'R3: Recycling/recovery of organic substances not used as solvents',
  'R4: Recycling/recovery of metals and metal compounds',
  'R5: Recycling/recovery of other inorganic substances',
  'R6: Recovery of acids or bases',
  'R7: Recovery of components used to combat pollution',
  'R8: Recovery of components from catalysts',
  'R9: Rerefinement of oil and other reuse of oil',
  'R10: Agricultural or ecological improvement',
  'R11: Use of waste resulting from R1-R10 treatments',
  'R12: Exchange of waste for R1-R11 treatments',
  'R13: Storage of waste for R1-R12 treatments',
  'D1: Landfill (on or in land)',
  'D2: Land treatment (spreading for biodegradation)',
  'D3: Deep injection (into wells, salt domes)',
  'D4: Surface water impoundment (lagoons, ponds)',
  'D5: Specially engineered landfill',
  'D6: Release to water bodies (excluding seas/oceans)',
  'D7: Release into seas/oceans including seabed placement',
  'D8: Biological treatment not specified elsewhere',
  'D9: Physico-chemical treatment not specified elsewhere',
  'D10: Incineration on land',
  'D11: Incineration at sea',
  'D12: Permanent storage (e.g., placement in mines)',
  'D13: Blending before D1-D12 treatment',
  'D14: Repackaging before D1-D13 treatment',
  'D15: Storage pending D1-D14 treatment',
]

export const SENDERS = [
  'Regio Gooi en Vechtstreek (GAD)',
  'PreZero Nederland',
  'Renewi Nederland B.V.',
  'Remondis',
  'Erasmus MC (Rotterdam)',
  'Tergooi MC',
  'BAM Bouw en Techniek',
  'Port of Rotterdam Authority',
  'Gemeente Amsterdam',
]

export const TRANSPORTERS = [
  'Regio Gooi en Vechtstreek (GAD)',
  'Renewi Nederland B.V.',
  'PreZero Nederland',
  'Simon Loos',
  'Remondis',
  'GP Groot',
  'Van Gansewinkel',
]

export const REPORTING_SYSTEMS = ['Basic System', 'Collector Scheme'] as const

export const INITIAL_AGREEMENTS: WasteStreamAgreement[] = [
  {
    id: '1',
    entity: { value: 'entity-3', label: 'Port of Rotterdam Authority' },
    disposer: 'Port of Rotterdam Authority',
    valid_from: '21.01.2026',
    reporting_system: 'Basic System',
    sender: 'Reinis N.V.',
    transporter: 'Reinis N.V.',
    is_active: true,
    waste_streams: [
      {
        id: 'ws-1',
        waste_type: 'PMD (Gemengde verpakkingen)(15 01 06)',
        receivers: [
          {
            id: 'rec-1',
            receiver: 'ATM Moerdijk',
            processing_method: 'Material Recovery',
            is_default: true,
          },
        ],
      },
    ],
  },
]
